import 'slick-carousel';
import BreakpointsEnum from './enums/breakpointsEnum';
import initSlickSliderObserver from "./observers/lazyLoading";
import {mainSliderOptions, popularCategorySliderOptions, productsSliderOptions} from "./common/sliderOptions";

require('./components/product');

let mainSlider = document.getElementById('mainSlider');
let popularCategorySlider = document.getElementById('popularCategoriesSlider');
let youWatchedSlider = document.getElementById('youWatchedSlider');
let popularProductsSlider = document.getElementById('popularProductsSlider');

try {
    initSlickSliderObserver(mainSlider, mainSliderOptions);
    initSlickSliderObserver(popularCategorySlider, popularCategorySliderOptions);
    initSlickSliderObserver(youWatchedSlider, productsSliderOptions);
    initSlickSliderObserver(popularProductsSlider, productsSliderOptions);
} catch (e) {
    console.error(e);
}

$(function () {
    initSlickSliderObserver(mainSlider, mainSliderOptions);
    initSlickSliderObserver(popularCategorySlider, popularCategorySliderOptions);
    initSlickSliderObserver(youWatchedSlider, productsSliderOptions);
    initSlickSliderObserver(popularProductsSlider, productsSliderOptions);

    $('#subscriptionForm').on('submit', '.js-subscription-form', function (e) {
        e.preventDefault();
        let $form = $(this);

        if ($form.data('ajax')) {
            return false;
        }

        $.ajax({
            type: 'POST',
            data: $form.serialize(),
            url: $(this).attr('action'),
            dataType: 'json',
            beforeSend: function () {
                $form.data('ajax', true);
            },
            success: function (response) {
                if (response.status === "OK") {
                    $form.reset();
                    App.analytics.sendAnalyticsGoal('podpiska_v_podvale');
                }

                if (response.status === "ERROR" && response.hasOwnProperty('errors')) {
                    $.each(response.errors, function (index, error) {
                        let $input = $form.find(`#${index}`).closest('.input-group');
                        $input.addClass('invalid');
                        $input.find('.feedback').html(error[0]);
                    });
                }

                return true;
            },
            complete: function () {
                $form.data('ajax', false);
            }
        });

        return false;
    });
});

$(window).on('load resize', () => {
    if ([BreakpointsEnum.desktop, BreakpointsEnum.largeDesktop].includes(window.App.getBreakpoint())) {
        initSlickSliderObserver(popularCategorySlider, popularCategorySliderOptions);
        initSlickSliderObserver(youWatchedSlider, productsSliderOptions);
        initSlickSliderObserver(popularProductsSlider, productsSliderOptions);
    }
});
